import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

export default function Heading({ level = "h1", tag, children, ...props }) {
  return (
    <Typography variant={level} component={tag || level} {...props}>
      {children}
    </Typography>
  );
}

Heading.propTypes = {
  level: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  tag: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  children: PropTypes.node.isRequired,
};
